<template lang="pug">
  div
    p.form-control-static 選択中：
      tag-color(:rgb="value.color_rgb", :outline="outline")

    //- 選択する場所
    loading(v-if="isLoading", :height="86")
    ul(v-else)
      li(v-for="color in tag_colors", :key="color.id", :class="{active: value.color === color.id}", @click="select(color)")
        tag-color(:rgb="color.rgb", :outline="outline")

</template>

<script>
import TagColor from '@/components/molecules/TagColor'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

export default {
  name: 'SelectTagColor',
  components: { TagColor, Loading },
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          color: '',
          color_rgb: '',
          openflag: '1'
        }
      }
    },
    /**
     * 'mgtag' or 'pvtag'
     */
    type: {required: true, type: String}
  },
  data: function () {
    return {
      isLoading: true,
      tag_colors: []
    }
  },
  computed: {
    outline: function () {
      return this.value.openflag === this.app_flag.OFF
    }
  },
  created: function () {
    const vm = this
    let repo

    if (this.type === 'mgtag') {
      repo = RepositoryFactory.get('mgtag')
    }
    else {
      repo = RepositoryFactory.get('pvtag')
    }

    // 初期データ取得
    repo.getColors()
      .then(function (response) {
        vm.tag_colors = vm.getApiData(response).data.tag_colors
        // 初期選択肢の設定
        if (!vm.value.color && vm.tag_colors.length) vm.select(vm.tag_colors[0])
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
      .finally(function () {
        vm.isLoading = false
      })
  },
  methods: {
    select: function (color) {
      let item = this.value
      item.color = color.id
      item.color_rgb = color.rgb
      this.$emit('input', item)
    }
  }
}
</script>

<style lang="scss" scoped>
/* リストを用いる形式 */
ul {
  width: 274px;
  margin: 0;
  padding: 0;

  border-radius: 4px;
  border: solid 1px #adadad;
  list-style: none;

  & > li {
    padding: 10px;

    display: inline-block;
    cursor: pointer;
  }

  li:hover {
    background-color: #e6e6e6;
  }

  li.active {
    background-color: lightblue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/TagEditColor.vue